import { QUERY_KEYS } from "../../../../constants/queryKeys";

const DEFAULT_INDEX = 0;
const MINIMUM_INDEX = 0;
const { TAB } = QUERY_KEYS;

type Input = {
  contentsCount: number;
  search: string;
};
type Output = number;
type GetSelectedTabIndex = (input: Input) => Output;

export const getSelectedTabIndex: GetSelectedTabIndex = (input) => {
  const { contentsCount, search } = input;
  const queryParameters = new URLSearchParams(search);
  const maybeSelectedTabIndex = queryParameters.get(TAB);
  const castedIndex = Math.floor(Number(maybeSelectedTabIndex));
  if (isNaN(castedIndex) || !isFinite(castedIndex)) return DEFAULT_INDEX;
  if (castedIndex < MINIMUM_INDEX || castedIndex >= contentsCount)
    return DEFAULT_INDEX;
  return castedIndex;
};
